// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/icon-template/src/index.tsx

import baseIcon, { defaultIconGroupProps } from '@bubble-ui/temp-icon-base';
var IconHelpPath = 'M11.542 13.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0ZM7 7.586h2c0-.136.117-.254.187-.312.215-.18.631-.34 1.162-.248.423.076.676.32.72.467v.002c.017.058.054.19-.138.374l-.977.974A3.002 3.002 0 0 0 9.042 11l2-.039c0-.248.111-.49.322-.699l.969-.965c.659-.64.903-1.526.654-2.369-.277-.938-1.175-1.672-2.288-1.869-1.025-.184-2.07.074-2.797.683C7.321 6.228 7 6.884 7 7.586Z M0 10C0 4.486 4.486 0 10 0s10 4.486 10 10-4.486 10-10 10S0 15.514 0 10Zm2 0c0 4.411 3.589 8 8 8s8-3.589 8-8-3.589-8-8-8-8 3.589-8 8Z';
var IconHelp = baseIcon('IconHelp', {
  groupProps: defaultIconGroupProps,
  getPath: () => IconHelpPath
});
export default IconHelp;
//# sourceMappingURL=index.js.map